export const alloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillCounts =
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/backfill_counts";
